module.exports = __webpack_public_path__ + "fonts/CrimsonText-Bold.1fe721e7.woff";